/**
 * session 相关存储收口：统一使用 sessionStorage 存取，保证同一标签页会话内一致。
 */
import { CACHE_PREFIX } from '../const/caches'

const SESSION_ID_KEY = `${CACHE_PREFIX}:session_id`
const SESSION_DURATION_KEY = `${CACHE_PREFIX}:session_time`

/** 读取缓存的 session_id，无则返回 undefined */
export function getSessionIdCache(): string | undefined {
  try {
    return sessionStorage.getItem(SESSION_ID_KEY) || undefined
  } catch (error) {
    console.error('getSessionIdCache error :>> ', error)
    return undefined
  }
}

/** 写入 session_id */
export function setSessionIdCache(id: string): void {
  try {
    sessionStorage.setItem(SESSION_ID_KEY, id)
  } catch (error) {
    console.error('setSessionIdCache error :>> ', error)
  }
}

/** 移除 session_id */
export function removeSessionIdCache(): void {
  try {
    sessionStorage.removeItem(SESSION_ID_KEY)
  } catch (error) {
    console.error('removeSessionIdCache error :>> ', error)
  }
}

/** 读取缓存的 session 起始时间戳，无则返回 undefined */
export function getSessionStartTimeCache(): number | undefined {
  try {
    const raw = sessionStorage.getItem(SESSION_DURATION_KEY)
    if (!raw) return undefined
    const time = Number(raw)
    return Number.isNaN(time) ? undefined : time
  } catch (error) {
    console.error('getSessionStartTimeCache error :>> ', error)
    return undefined
  }
}

/** 写入 session 起始时间戳 */
export function setSessionStartTimeCache(time: number): void {
  try {
    sessionStorage.setItem(SESSION_DURATION_KEY, String(time))
  } catch (error) {
    console.error('setSessionStartTimeCache error :>> ', error)
  }
}

/** 移除 session 起始时间戳 */
export function removeSessionStartTimeCache(): void {
  try {
    sessionStorage.removeItem(SESSION_DURATION_KEY)
  } catch (error) {
    console.error('removeSessionStartTimeCache error :>> ', error)
  }
}
